/*
 * This unpublished material is proprietary to Vaticle.
 * All rights reserved. The methods and
 * techniques described herein are considered trade secrets
 * and/or confidential. Reproduction or distribution, in whole
 * or in part, is forbidden except by express written permission
 * of Vaticle.
 */

import { Pipe, PipeTransform } from "@angular/core";
import { MachineType, machineTypeComputeString, machineTypeCpuString, machineTypeRamString, machineTypeToString } from "../../concept/cluster-deployment-options";

@Pipe({
    name: "machineType",
    standalone: true,
})
export class MachineTypePipe implements PipeTransform {
    transform(value: MachineType, ...args: string[]): string {
        switch (args[0]) {
            case "compute": return machineTypeComputeString(value);
            case "cpu": return machineTypeCpuString(value);
            case "ram": return machineTypeRamString(value);
            default: return machineTypeToString(value);
        }
    }
}
